
export function formatDateToDDMMYYYY(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth é zero-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  export function formataDataEmDDMMYYYYHM(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} às ${hours}:${min}`;
}

export function formataDataAsHoras(date: string) {
  const data = new Date(date);

  const dateOptions = {
    day: '2-digit',  
    month: '2-digit', 
    year: 'numeric'   
  };

  const timeOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false 
  };

  const dataFormatada = data.toLocaleDateString('pt-BR', dateOptions);  
  const horaFormatada = data.toLocaleTimeString('pt-BR', timeOptions);

  return `${dataFormatada} às ${horaFormatada}`;
}
